import React from "react";
import PropTypes from "prop-types";

const Page = props => {
  const { title, children, lightIcon } = props;
  return (
    <div className="page">
      <div className="page__header">
        <div className="page__container page__titleRow">
          {!lightIcon ? null : <img src={lightIcon} alt={title} />}
          <h1 className="page__title" style={{ textTransform: "capitalize" }}>
            {title}
          </h1>
        </div>
      </div>
      <div className="page__body">
        <div className="page__container">{children}</div>
      </div>
      <div className="page__footer">
        <div className="page__container" />
      </div>
    </div>
  );
};

Page.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  lightIcon: PropTypes.string
};

Page.defaultProps = {
  title: null,
  children: null,
  lightIcon: null
};

export default Page;
